var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "align-content": "center",
        "padding-left": "5px"
      }
    },
    [
      _c("span", { style: _vm.styleCurrency }, [
        _vm._v(_vm._s(_vm.total.currency))
      ]),
      _c("span", { style: _vm.style }, [_vm._v(_vm._s(_vm.total.amount))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }